module.exports = __webpack_public_path__ + "3ee9e5222b09b67fd873ca1cfd0c4490.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/ja.json
// module id = 1120
// module chunks = 0